<template>
  <div class="footer">
    <div class="bg">
      <div class="container">
        <div class="row">
          <dl class="col-sm-3 adress">
            <dt>{{$t('addressInfo.name')}}</dt>
            <dd><i class="glyphicon glyphicon-map-marker"></i>{{$t('addressInfo.address')}}</dd>
            <dd>
              <i class="glyphicon glyphicon-phone-alt"></i>{{$t('addressInfo.hotline')}}
              <a href="tel:0572-2700168">0572-2700168</a>
              <a href="tel:0572-2700155">0572-2700155</a>
            </dd>
            <dd><i class="glyphicon glyphicon-envelope"></i>{{$t('addressInfo.mailbox')}}zjjb@zjjingbao.com</dd>
            <dd><i class="glyphicon glyphicon-home"></i>{{$t('addressInfo.website')}}www.hzjingbao.cn</dd>
          </dl>
          <div>
            
            <dl class="col-xs-6 col-sm-3 text-center" v-for="(item,index) in footnav" :key="index">
              <dt>{{item.name}}</dt>
              <router-link :to="{path:'/'+item.url+'/'+option.id}" tag="dd" v-for="(option,index) in item.subnavigation" :key="index" exact>
                {{option.subname}}
              </router-link>
            </dl>
             <dl class="col-xs-6 col-sm-3 text-center" >
              <dt>{{$t('nav_foot[1].name')}}</dt>
              <router-link :to="{path:it.url}" tag="dd" v-for="(it,i) in productdata" :key="i" exact>
                {{it.p1}}
              </router-link>
            </dl>
            <!-- <dl class="col-xs-6 col-sm-2 text-center">
              <dt>产品展示</dt>
              <dd>可再分散性乳胶</dd>
              <dd>单组份木胶粉</dd>
              <dd>纯脲醛树脂原粉</dd>
              <dd>环保型脲醛树脂原粉</dd>
            </dl>
            <dl class="col-xs-6 col-sm-2 text-center">
              <dt>新闻资讯</dt>
              <dd>公司新闻</dd>
              <dd>行业资讯</dd>
            </dl> -->
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">
      <div class="text-center">
      <p style="margin:0;">Copyright © {{$t('Copyright.key')}} {{timedate}} {{$t('Copyright.value')}}
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33059102000140" 
        style="display:inline-block;text-decoration:none;"><p style="margin: 0px 0px 0px 20px; color:#939393;">
          <img src="../assets/images/备案图标.png">浙公网安备 33059102000140号</p></a>
          </p> 
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      //footnav:[this.$t('nav_foot[0]'),this.$t('nav_foot[1]')]
      timedate:""
    };
  },
  computed:{
    footnav(){
      return [this.$t('nav_foot[0]'),this.$t('nav_foot[2]')]
    },
     productdata() {
      return this.$t("productnav");
    }
  },
  created(){
  },
  watch: {
    
   
  },
  mounted(){
    //  this.$http
    //   .get("http://www.hzjingbao.cn/api/category", {
    //     params: {
    //       lang: this.$i18n.locale
    //     }
    //   })
    //   .then(res => {
    //     //console.log(res.data);
    //     if (this.productdata.length < 4) {
    //       this.productdata.push(...res.data);
    //     }

    //    // console.log(this.productdata.length);
    //   })
    //   .catch(erroe => {
    //     console.log(error);
    //   })

      var time = new Date();
      console.log(time.getFullYear());
      this.timedate=time.getFullYear();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/footer.vue